import React, { useContext } from 'react';
import { Chip } from '@material-ui/core';
import { I18nContext } from 'translations';

// Shown on a package's card once its route has been relaunched and this package was part of
// that batch — see Api::Web::Pibox::Package::ShowSerializer#relaunched (picap_api).
export default function RelaunchedChip() {
  const { translate } = useContext(I18nContext);

  return (
    <Chip
      size="small"
      data-testid="package-relaunched-chip"
      label={translate('app.deliveryRoute.relaunched')}
      style={{ backgroundColor: '#F5A623', color: '#fff', fontWeight: 600 }}
    />
  );
}
